var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Search Item/ Belonging")]),_c('v-container',{staticClass:"main-section-itemsbelongings-list ma-1 pa-1",attrs:{"fluid":""}},[_c('ItemsBelongingstList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }